import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChargeDto } from '@tiendanube/common';
import { PaymentMethodSelection } from './types';
import { initialState } from './utils';

const checkout = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    selectPaymentMethod(
      state,
      { payload }: PayloadAction<PaymentMethodSelection>,
    ) {
      state.paymentMethodSelected = payload;
    },
    setChargesToPaySelected(state, { payload }: PayloadAction<ChargeDto[]>) {
      state.chargesToPaySelected = payload;
    },
  },
});

export const { reducer } = checkout;

export const { selectPaymentMethod, setChargesToPaySelected } =
  checkout.actions;
